import Script from 'next/script'
import { enabledTrackers } from './utils'
import { getPublicRuntimeConfig } from '../../config/runtime'

export default function Tracker() {
  const { tracker: trackerConfig } = getPublicRuntimeConfig()
  return (
    <>
      {enabledTrackers.map(tracker => (
        <>
          {tracker.scriptSrc && (
            <Script
              key={`${tracker.key}-src`}
              id={`${tracker.key}-src`}
              src={tracker.scriptSrc(trackerConfig[tracker.key])}
            />
          )}
          {tracker.script && (
            <Script key={tracker.key} id={tracker.key} strategy="afterInteractive">
              {tracker.script(trackerConfig[tracker.key])}
            </Script>
          )}
        </>
      ))}
    </>
  )
}
